<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="计划账户操作id" prop="scheduleAccountOperateId">
          <el-input v-model="dataForm.scheduleAccountOperateId" placeholder="计划账户操作id"></el-input>
      </el-form-item>
          <el-form-item label="公司id" prop="companyId">
          <el-input v-model="dataForm.companyId" placeholder="公司id"></el-input>
      </el-form-item>
          <el-form-item label="流水号" prop="serialNumber">
          <el-input v-model="dataForm.serialNumber" placeholder="流水号"></el-input>
      </el-form-item>
          <el-form-item label="产生这条记录的草(0支出、1充值)" prop="type">
          <el-input v-model="dataForm.type" placeholder="产生这条记录的草(0支出、1充值)"></el-input>
      </el-form-item>
          <el-form-item label="状态(0无效,1有效)" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态(0无效,1有效)"></el-input>
      </el-form-item>
          <el-form-item label="默认0未复核,1已复核" prop="reviewersStatus">
          <el-input v-model="dataForm.reviewersStatus" placeholder="默认0未复核,1已复核"></el-input>
      </el-form-item>
          <el-form-item label="复核人" prop="reviewers">
          <el-input v-model="dataForm.reviewers" placeholder="复核人"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
              <el-form-item label="更新者" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新者"></el-input>
      </el-form-item>
          <el-form-item label="更新时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新时间"></el-input>
      </el-form-item>
          <el-form-item label="记录产生原因" prop="recordTheCause">
          <el-input v-model="dataForm.recordTheCause" placeholder="记录产生原因"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        scheduleAccountOperateId: '',
        companyId: '',
        serialNumber: '',
        type: '',
        status: '',
        reviewersStatus: '',
        reviewers: '',
        remark: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        recordTheCause: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        scheduleAccountOperateId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        serialNumber: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        reviewersStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        reviewers: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        recordTheCause: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/tscheduleaccountoperatelog/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/tscheduleaccountoperatelog/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
